Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
CardMemberSelectView = require 'views/card/card-member-select-view'
DatePickerView = require 'views/card/date-picker-view'
trackUe = require 'debug/trackUe'
{ getUpNextOverflowItems } = require './presentational/util/up-next'
{ getHighlightsOverflowItems } = require './presentational/util/highlight'
{ getDueDatesOverflowItems } = require './presentational/util/due-date'

UP_NEXT_TYPE = 'UP_NEXT'
HIGHLIGHT_TYPE = 'HIGHLIGHTS'
DUE_DATE_TYPE = 'DUE_DATES'

onClickSubscribe = (card) =>
  card.subscribe(true)
  PopOver.hide()

onClickUnsubscribe = (card) =>
  card.subscribe(false)
  PopOver.hide()

onClickDueDate = (card, modelCache) =>
  PopOver.pushView
    view: DatePickerView
    options: { model: card, modelCache, trackingCategory: 'home' }

onClickAddMembers = (card, modelCache) =>
  PopOver.pushView
    view: CardMemberSelectView
    options: { model: card, modelCache }

onClickJoinCard = (card) =>
  card.addMember(Auth.myId())
  PopOver.hide()

onClickLeaveCard = (card) =>
  card.removeMember(Auth.myId())
  PopOver.hide()

getOverflowItems = (card, type, modelCache, args...) =>
  if type != UP_NEXT_TYPE && type != HIGHLIGHT_TYPE && type != DUE_DATE_TYPE
    throw new Error('invalid feed type')

  cardInfo =
    cardId: card.id
    editable: card.editable()
    isSubscribed: card.isSubscribed()
    hasDueDate: card.getDueDate()?
    hasMeAsMember: card.hasMember(Auth.myId())

  handlers =
    subscribe: => onClickSubscribe(card)
    unsubscribe: => onClickUnsubscribe(card)
    addDueDate: => onClickDueDate(card, modelCache)
    changeDueDate: => onClickDueDate(card, modelCache)
    addMembers: => onClickAddMembers(card, modelCache)
    joinCard: => onClickJoinCard(card)
    leaveCard: => onClickLeaveCard(card)

  if type == UP_NEXT_TYPE
    return getUpNextOverflowItems(cardInfo, handlers, args...)
  if type == HIGHLIGHT_TYPE
    return getHighlightsOverflowItems(cardInfo, handlers, args...)
  if type == DUE_DATE_TYPE
    return getDueDatesOverflowItems(cardInfo, handlers, args...)

module.exports = {
  getOverflowItems
  UP_NEXT_TYPE
  HIGHLIGHT_TYPE
  DUE_DATE_TYPE
}



// WEBPACK FOOTER //
// ./app/scripts/views/home/overflow-menu.coffee